/**
 * @file コンポーネント：ノート削除モーダル ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnHandleApiErrors } from "~/src/functions/common";

// コンポーネントを返す
export const ModalNoteDelete = (props) => {
    /**
     * キャンセルボタンクリック
     */
    const fnOnClickCancel = (e) => {
        e.preventDefault();
        props.setIsOpenModal(false);
    };

    /**
     * 削除ボタンクリック
     */
    const fnOnClickDelete = (e) => {
        e.preventDefault();
        const api = "/api/Notes/delete";
        const options = {
            body: JSON.stringify({
                noteId: props.noteId,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        fetch(api, options)
            .then(fnHandleApiErrors)
            .then((response) => {
                if (response.status === 200) {
                    // 成功時、現在のページセット関数が渡されていれば1ページ目に戻す処理
                    if (props.setCurrentPage !== undefined) {
                        const promise = new Promise((resolve) => {
                            props.setCurrentPage(null);
                            resolve(void {});
                        });
                        promise.then(() => {
                            // ノートドロワーが開いている場合は閉じる
                            if (props.setIsOpenDrawerNote !== undefined) {
                                props.setIsOpenDrawerNote(false);
                            }
                            // 処理にラグが無いと親コンポーネントでpropsの変更を検知しないため遅延させる
                            setTimeout(() => {
                                props.setCurrentPage(1);
                            }, 100);
                        });
                    }
                }
                props.setIsOpenModal(false);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClickCancel={fnOnClickCancel}
            fnOnClickDelete={fnOnClickDelete}
        />
    );
};
